import { render } from "./WorkCard.vue?vue&type=template&id=1879a146&scoped=true"
import script from "./WorkCard.vue?vue&type=script&lang=js"
export * from "./WorkCard.vue?vue&type=script&lang=js"

import "./WorkCard.vue?vue&type=style&index=0&id=1879a146&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1879a146"

export default script